import old from "../../images/questionIcons/Jordans-old.jpeg";
import newImg from "../../images/questionIcons/Jordans-new.jpeg";
import bigMacOld from "../../images/questionIcons/BigMac-old.jpeg";
import bigMacNew from "../../images/questionIcons/BigMac-new.jpeg";
import houseOld from "../../images/questionIcons/House-old.jpeg";
import houseNew from "../../images/questionIcons/House-new.jpeg";
import TVOld from "../../images/questionIcons/TV-old.jpeg";
import TVNew from "../../images/questionIcons/TV-new.jpeg";
import fordOld from "../../images/questionIcons/ford-old.jpeg";
import fordNew from "../../images/questionIcons/ford-new.jpeg";
import LEGOOld from "../../images/questionIcons/LEGO-old.jpeg";
import LEGONew from "../../images/questionIcons/LEGO-new.jpeg";
import ToothFairyOld from "../../images/questionIcons/Tooth-fairy-old.jpeg";
import ToothFairyNew from "../../images/questionIcons/Tooth-fairy-new.jpeg";
import RuddOld from "../../images/questionIcons/Rudd-old.jpeg";
import RuddNew from "../../images/questionIcons/Rudd-new.jpeg";
import UnderwearOld from "../../images/questionIcons/Underwear-old.jpeg";
import UnderwearNew from "../../images/questionIcons/Underwear-new.jpeg";
import InsulinOld from "../../images/questionIcons/Insulin-old.jpeg";
import InsulinNew from "../../images/questionIcons/Insulin-old.jpeg";
import Q1 from "../../images/G1.svg";
import Q2 from "../../images/G2.svg";
import Q3 from "../../images/G3.svg";
import Q4 from "../../images/G4.svg";
import Q5 from "../../images/G5.svg";
import Q6 from "../../images/G6.svg";
import Q7 from "../../images/G7.svg";
import Q8 from "../../images/G8.svg";
import Q9 from "../../images/G9.svg";
import Q10 from "../../images/G10.svg";

const questionSet = [
  {
    title: "Adjusting for inflation, which is cheaper?",
    subTitle: "AIR JORDANS",
    answer: 2, //2 mean new image selection is correct
    detailText:
      "$56.95 is $156.09 in today’s dollars. Therefore, the 2022 rerelease of Nike Air Jordans are actually cheaper now than in 1985 after adjusting for inflation (although a genuine vintage pair of 1985 Jordans will set you back tens of thousands of dollars). Generally, clothing and shoes have fallen in price over time due to more automation in the production process and global competition.",
    sourcesText:
      '<span style="color: #898989;">SOURCES:</span> Period advertisement (old price), Nike.com as of 3/22 (new price)',
    old: {
      price: "56.95",
      year: 1985,
      cpi: 108,
      image: old,
    },
    new: {
      price: "140.00",
      year: 2022,
      cpi: 296,
      image: newImg,
    },
    equation: Q1,
    inflation: {
      price: "156.09",
      year: 2022,
    },
  },

  {
    title: "Adjusting for inflation, which is cheaper?",
    subTitle: "BIG MAC",
    answer: 1,
    detailText:
      "$0.49 is $4.14 in today’s dollars. Therefore, after adjusting for inflation, the original Big Mac is cheaper than a Big Mac currently (although regional prices may vary). Food prices, in general, have remained fairly stable in the U.S. over the past 50 years, with some items increasing in price and others decreasing.",
    sourcesText:
      "<span style='color: #898989;'>SOURCES:</span> Period advertisement (old price), McDonald's app in Los Angeles (new price)",
    old: {
      price: "0.49",
      year: 1968,
      cpi: 35,
      image: bigMacOld,
    },
    new: {
      price: "5.29",
      year: 2022,
      cpi: 296,
      image: bigMacNew,
    },
    equation: Q2,
    inflation: {
      price: "4.14",
      year: 2022,
    },
  },

  {
    title: "Adjusting for inflation, which is cheaper?",
    subTitle: "LOS ANGELES HOUSE",
    answer: 1, //1 mean old image selection is correct
    detailText:
      "$43,500 is $225,895 in today’s dollars. Therefore, after adjusting for inflation, the home has quadrupled in price (despite not being remodeled in 46 years!). This is not uncommon in America’s most desirable cities—the supply of housing has not kept up with demand, causing prices to spiral upwards.",
    sourcesText: '<span style="color: #898989;">SOURCE:</span> Redfin.com',
    old: {
      price: "43,500",
      year: 1976,
      cpi: 57,
      image: houseOld,
    },
    new: {
      price: "911,963",
      year: 2022,
      cpi: 296,
      image: houseNew,
    },
    equation: Q3,
    inflation: {
      price: "225,895",
      year: 2022,
    },
  },

  {
    title: "Adjusting for inflation, which is cheaper?",
    subTitle: '27" TELEVISION',
    answer: 2,
    detailText:
      "$279.95 is $3,069 in today’s dollars. TVs today, despite being of much higher quality than those of the past, are actually far cheaper after adjusting for inflation. In fact, few goods have decreased in price more than TVs. This is primarily because of global competition and innovation.",
    sourcesText:
      '<span style="color: #898989;">SOURCES:</span> Period advertisement (old price), <a  style="color: #898989" target="_black" href="https://www.amazon.com/">Amazon.com</a> as of 3/22 (new price)',
    old: {
      price: "279.95",
      year: 1953,
      cpi: 27,
      image: TVOld,
    },
    new: {
      price: "449.94",
      year: 2022,
      cpi: 296,
      image: TVNew,
    },
    equation: Q4,
    inflation: {
      price: "3,069",
      year: 2022,
    },
  },

  {
    title: "Adjusting for inflation, which is cheaper?",
    subTitle: "FORD SEDAN",
    answer: 2,
    detailText:
      "$850 is $24,461 in 2020 dollars. A Ford Model T was actually more expensive in 1909 than a far superior Ford Sedan in 2020 (the last year Ford sold sedans). Cars, in general, have held steady in price over time despite improving in both technology and comforts.",
    sourcesText:
      '<span style="color: #898989;">SOURCES:</span> Period advertisement (old price), <a  style="color: #898989" target="_black" href="https://www.kbb.com/">KBB.com</a> (new price for 2020 Ford Fusion)',
    old: {
      price: "850",
      year: 1909,
      cpi: 9,
      image: fordOld,
    },
    new: {
      price: "23,170",
      year: 2020,
      cpi: 259,
      image: fordNew,
    },
    equation: Q5,
    inflation: {
      price: "24,461",
      year: 2020,
    },
  },

  {
    title: "Adjusting for inflation, which is cheaper?",
    subTitle: "LEGO X-WING FIGHTER",
    answer: 2,
    detailText:
      "$30 is $53.17 in today's dollars, so the current Lego is slightly cheaper. However, the current Lego is larger and contains roughly double the Lego bricks. On a per piece basis, the 1999 X Wing cost 19.3 cents per lego piece (after adjusting for inflation) while the 2022 X wing cost 10.5 cents per piece. This is roughly a 50% decline in price. In general, toys have had one of the most significant drops in price since 1999, with an average drop of over 50% in price. So it seems good to be a kid, but have kids’ income increased?",
    sourcesText:
      '<span style="color: #898989;">SOURCES:</span> Period advertisement (old price), <a  style="color: #898989" target="_black" href="https://www.amazon.com/">Amazon.com</a> (new price)',
    old: {
      price: "30",
      year: 1999,
      cpi: 167,
      image: LEGOOld,
    },
    new: {
      price: "50",
      year: 2022,
      cpi: 296,
      image: LEGONew,
    },
    equation: Q6,
    inflation: {
      price: "53.17",
      year: 2022,
    },
  },

  {
    title: "Adjusting for inflation, which is cheaper?",
    subTitle: "TOOTH FAIRY (average tooth price)",
    answer: 1,
    detailText: "$1.60 is $2.68 in today's dollars. That means the amount the tooth fairy gives out has doubled since 2001. Taken in conjunction with the drop in toy prices, the purchasing power of kids has greatly expanded over the previous two decades.",
    sourcesText:
      '<span style="color: #898989;">SOURCE:</span> <a  style="color: #898989" target="_black" href="www.deltadental.com/us/en/tooth-fairy/the-original-poll.html">Delta Dental Poll</a>',
    old: {
      price: "1.60",
      year: 2001,
      cpi: 177,
      image: ToothFairyOld,
    },
    new: {
      price: "5.36",
      year: 2022,
      cpi: 296,
      image: ToothFairyNew,
    },
    equation: Q7,
    inflation: {
      price: "2.68",
      year: 2022,
    },
  },
  {
    title: "Adjusting for inflation, which is cheaper?",
    subTitle: "PAUL RUDD ACTING FEE",
    answer: 1,
    detailText:
      "$150,000 is $233,882 in 2015 dollars. Even though his looks have not changed, his paycheck has. After adjusting for inflation Paul Rudd’s estimated $150,000 salary for Clueless would be less than the $300,000 check he got for Antman in 2015.",
    sourcesText:
      '<span style="color: #898989;">SOURCES:</span> "Clueless" salary estimated from leading role salaries at the time. "Antman" salary from <a  style="color: #898989" target="_black" href="https://news.yahoo.com/">Yahoo News</a>.',
    old: {
      price: "150,000",
      // asteric: "*",
      year: 1995,
      yearWithText: "1995 (Clueless)",
      cpi: 152,
      image: RuddOld,
    },
    new: {
      price: "300,000",
      // asteric: "*",
      year: 2015,
      yearWithText: "2015 (AntMan)",
      cpi: 237,
      image: RuddNew,
    },
    equation: Q8,
    inflation: {
      price: "233,282",
      year: 2015,
    },
  },
  ///
  {
    title: "Adjusting for inflation, which is cheaper?",
    subTitle: "UNDERWEAR",
    answer: 2,
    detailText: "$1.00 is $12.33 in 2022 dollars. Underwear, like most clothing, has gone down in price over time.",
    sourcesText:
      '<span style="color: #898989;">SOURCES:</span> Period advertisement (old price), <a  style="color: #898989" target="_black" href="https://www.amazon.com/">Amazon.com</a> (new price)',
    old: {
      price: "1.00",
      year: 1949,
      cpi: 24,
      image: UnderwearOld,
    },
    new: {
      price: "4.03",
      year: 2022,
      cpi: 296,
      image: UnderwearNew,
    },
    equation: Q9,
    inflation: {
      price: "12.33",
      year: 2022,
    },
  },
  {
    title: "Adjusting for inflation, which is cheaper?",
    subTitle: "LONG ACTING INSULIN (per unit)",
    answer: 1,
    detailText:
      "$0.05 is $0.073 in 2020 dollars. Many medical treatment and pharmaceutical markets are heavily concentrated. Production is dominated by a few firms and regulations prevent foreign competition. In general, markets that lack competition (such as medicine) have seen significant price increases.",
    sourcesText:
      '<span style="color: #898989;">SOURCES:</span> <a  style="color: #898989" target="_black" href="http://americanactionforum.org/insight/insulin-prices-an-update/">Americanactionforum.org</a>',
    old: {
      price: "0.05",
      year: 2001,
      cpi: 177,
      image: InsulinOld,
    },
    new: {
      price: "0.25",
      year: 2020,
      cpi: 259,
      image: InsulinNew,
    },
    equation: Q10,
    inflation: {
      price: "0.073",
      year: 2020,
    },
  },
];

export default questionSet;
